(() => {
  const MOBILE_MAX_WIDTH = 768;

  function initPagesNavbar(container) {
    const swiperEl = container.querySelector('.pageNavbar');
    const nextEl = container.querySelector('.page-nav-next');
    const prevEl = container.querySelector('.page-nav-prev');
    let menuSwiper = null;

    function setActiveSlideIndex(swiper) {
      swiper.slides.forEach((slide, index) => {
        slide.setAttribute('data-slide-index', index);

        if (slide.classList.contains('activeClass')) {
          setTimeout(() => {
            const slideIndex = parseInt(slide.getAttribute('data-slide-index'), 10);
            const sliderPosition = slideIndex - 1 >= 0 ? slideIndex - 1 : 0;
            menuSwiper?.slideTo(sliderPosition);
          }, 1000);
        }
      });
    }

    function initializeSwiper() {
      if (window.innerWidth > MOBILE_MAX_WIDTH || menuSwiper || !swiperEl) {
        return;
      }

      menuSwiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        navigation: {
          nextEl,
          prevEl,
        },
        on: {
          init(swiper) {
            setActiveSlideIndex(swiper);
          },
        },
      });
    }

    function destroySwiper() {
      if (window.innerWidth <= MOBILE_MAX_WIDTH || !menuSwiper) {
        return;
      }

      menuSwiper.destroy(true, true);
      menuSwiper = null;
    }

    function checkScreenWidth() {
      if (window.innerWidth <= MOBILE_MAX_WIDTH) {
        initializeSwiper();
      } else {
        destroySwiper();
      }
    }

    checkScreenWidth();
    window.addEventListener('resize', checkScreenWidth);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-pages-navbar]').forEach(initPagesNavbar);
  });
})();
